import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const useQueryParams = <T = string>(key: string, defaultValue?: T) => {
	const [params, setParams] = useSearchParams();

	const setParam = useCallback(
		(value: T) => {
			setParams((p) => {
				if (value === null) {
					p.delete(key);
					return p;
				}
				return { ...p, [key]: value };
			});
		},
		[key, setParams]
	);

	return useMemo(
		() =>
			[(params.get(key) as T) || defaultValue, setParam] as [
				T,
				(value: T | null) => void
			],
		[params, setParam, defaultValue, key]
	);
};

export default useQueryParams;
